import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Shield } from "lucide-react";

// Staff/admin login (email + password). Not linked from the public UI — regular
// users sign in with Google only. This route exists so the admin can reach /admin.
export default function AdminLogin() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      toast.success("Welcome back!");
      navigate(data.user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1B16] p-6">
      <div className="w-full max-w-sm bg-[#FDFDF9] rounded-2xl p-8 shadow-xl">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-[#2D6A4F] flex items-center justify-center">
            <Shield className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-xl">Staff sign in</span>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="admin-login-email" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11 rounded-xl" placeholder="admin@…" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="admin-login-password" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11 rounded-xl" placeholder="••••••••" />
          </div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
                  className="w-full h-12 rounded-full bg-[#2D6A4F] hover:bg-[#1B4332] text-white text-base">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
